import { HttpClient } from "_fil_local_addon/camc-cms-base/index";
import { FUND_API_SOURCES } from "_fil_local_addon/camc-cms-base/amc_fund_api.constant";
import { UrlTool } from "_fil_local_addon/camc-cms-base/index";
import FundReportService from "_fil_local_addon/camc-fund-report-list/fund_report_service";

class CAMCFundFOF {
    constructor(fundCode, reportTime) {
        this.fundCode = fundCode;
        this.reportTime = reportTime;
        this.reportTime = null;
        this.httpClient = new HttpClient();
        this.fof_data_api = FUND_API_SOURCES.FUND_PORTFOLIO_SECURITIES_SOURCE;
    }

    async render() {
        try {
            this.reportTime = await FundReportService.getReportTime(this.fundCode);
            if (!this.reportTime) {
                this.setEmptyMessage();
            } else {
                const FOFData = await this.getFOFData();
                this.renderFOFData(FOFData);
            }
        } catch (error) {
            this.setEmptyMessage();
        }
        if (!this.reportTime) {
            this.setEmptyMessage();
            return;
        } else {
            const fofApiData = await this.getFOFData();
            this.renderFOFData(fofApiData);
        }
    }

    async getFOFData() {
        const fofUrl = UrlTool.addPath(this.fof_data_api, this.fundCode);
        let options = {
            errorHandler: () => {
                this.errorHandler();
            },
            data: {
                asat: this.reportTime,
            },
        };
        const FOFData = await this.httpClient.get(fofUrl, options);
        return FOFData;
    }

    renderFOFData(FOFApiData) {
        let FOFDataArray = [];
        let FOFResData = FOFApiData.data;
        if (FOFResData && FOFResData.topSecurityList) {
            // const sortedList = FOFResData.topSecurityList.sort((a, b) => parseInt(a.orderId) - parseInt(b.orderId));
            const sortedList = FOFResData.topSecurityList;
            for (var i = 0; i < sortedList.length; i++) {
                FOFDataArray.push(sortedList[i]);
            }
        }
        this.updateFundDate(this.reportTime);
        this.generateFOFTable(FOFDataArray);
    }

    setEmptyMessage(containerId) {}

    errorHandler() {}

    updateFundDate(date) {}

    generateFOFTable(FOFDataArray) {}
}

export { CAMCFundFOF };
